export default __webpack_public_path__ + "static/media/Mark-2-Suit-Cycles-08.debd3be9.jpg";